export const configInjectionKey = Symbol('configInjectionKey')
export const initialPropsInjectionKey = Symbol('initialProps')
export const fluentInjectionKey = Symbol('fluent')
